import { render, staticRenderFns } from "./setWin.vue?vue&type=template&id=2c67f884&scoped=true&"
import script from "./setWin.vue?vue&type=script&lang=js&"
export * from "./setWin.vue?vue&type=script&lang=js&"
import style0 from "./setWin.vue?vue&type=style&index=0&id=2c67f884&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c67f884",
  null
  
)

export default component.exports